export const options = {
    map: {
        mapApiKey: process.env.REACT_APP_API_KEY_GOOGLE,
    },
    email: {
        emailToken: process.env.REACT_APP_EMAIL_TOKEN,
        emailAccount: process.env.REACT_APP_EMAIL_ACCOUNT,
        emailPass: process.env.REACT_APP_EMAIL_PASS
    },
    api: {
        url: process.env.REACT_APP_URL_API,
        jwtSecret: process.env.REACT_APP_SECRET_JWT
    }
};